module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAQAAAD8IX00AAAAE0lEQVQIW2NgYGDwYAATIAjhAQAOJQFpD8Tw9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/lattice.png
// module id = 547
// module chunks = 0